export default {
    xboot: "Jee 是很不错的一站式前后端分离快速开发平台",
    usernameLogin: "账户密码登录",
    mobileLogin: "手机短信登录",
    autoLogin: "自动登录",
    forgetPass: "忘记密码",
    otherLogin: "其他方式登录",
    regist: "注册账户",
    register: "注册",
    registering: "注册中...",
    registerNow: "还没有账号？立即注册",
    loginNow: "使用已有账号登录",
    login: "登录",
    logining: "登录中...",
    home: "首页",
    switchLangTitle: "切换语言",
    international: "多语言切换",
    userCenter: "个人中心",
    changePass: "修改密码",
    logOut: "退出登录",
    tagOption: "标签选项",
    closeAll: "关闭全部",
    closeOthers: "关闭其他",
    help: "帮助",
    privacy: "隐私",
    terms: "条款",
    rights: "版权所有",
    sso: "Jee统一认证平台",
    authorize: "授权",
    authorizeAndSignin: "授权并登录",
    authorizing: "授权中...",
    wants: "想要获取您的账户",
    wants2: "的权限",
    authAquire: "授权后，将获得以下用户数据",
    aquireInfo: "获得您的昵称、头像、性别",
    afterAuth: "授权后将会跳转至",
    relateTitle: "绑定Jee账号",
    relate: "立即绑定",
    relating: "绑定中...",
    textbtn: "文本",
    docbtn: "文档",
    autoDetection: "自动判断",
    standard: "标准2010",
    newstandard: "民委共享工程标准",
    menkcode: "蒙科立编码",
    translateSwitch: "划词翻译",
    translateOpen: "开",
    translateClose: "关",
    asr: "语音录入",
    copy: "复制",
    ononproduct: "Onon 应用",
    share: "分享",
    onondoc: "Onon 文库",
    ononoffice: "Onon Office",
    ononmap: "Onon 地图",
    en: "英文",
    zh: "中文",
    kiril: "西里尔文",
    ononime: "Onon 输入法",
    auxiliaryTranslation: "辅助翻译",
    mt: "智能翻译",
    ononfont: "Onon 字体",
    onondic: "Onon 词典",
    mnconvert: "蒙古文转换",
    ocr: "图片识别",
    tts: "语音合成",
    selectcode: "选择源文本编码类型（默认自动检测)",
    targetcode: "选择输出文本编码类型",
    platformnameforcodeconvert: "编码转换",
    platformnamefortranslate: "翻译",
    platformnameforconvert: "蒙古文转换",
    historybtn: "历史记录",
    clearhistory: "清除历史记录",
    historyview: "登录可查看历史记录",
    historynull: "没有历史记录",
    historyremoveall: "已清空所有历史记录",
    historyremoveforcurrent: "已从当前历史记录中移除",
    backtop: "返回顶部",
    resultXm: "形正确",
    resultErr: "错误",
    clear: "清除",
    transtip: "",
    accuracy: "准确率",
    shape: "形",
    sound: "音",
    dlhcode: "德力海编码",
    convertok: "转换",
    debounceinfo: "输入完文本后2500毫秒后发送请求，点击转换/翻译按钮700毫秒后发送请求",
    debouncetitle: "延迟请求提示",
    logout: "退出登录",
    favorites: "收藏夹",
    defaultObjSelectedName: "请选择目标编码",
    placholder: "请输入或粘贴待转换原文...",
    ononTrans: "翻译",
    ononConvert: "新旧转换",
    guideicon: "新手指引",
    nohistory: "暂无历史记录",
    uploadtip: "单击或拖动文件到此处进行上传",
    uploadsuffix: "请选择doc、docx文档",
    historygetdata: "只保存最近30条历史记录",
    step1: "准备转换",
    step2: "检查编码类型",
    step3: "转换中",
    step4: "转换完成",
    step_trans_1: "准备翻译",
    step_trans_2: "翻译中",
    step_trans_3: "翻译完成",

    company: "内蒙古斡仑科技有限公司 版权所有",

    tzh: "中文",
    ten: "英文",
    mo: "蒙古文",
    mobz: "蒙古文（标准编码）",
    momkl: "蒙古文（蒙科立编码）",
    momw: "蒙古文（民委标准编码）",
    selectlang: "选择源语种",
    objlang: "选择目标语种",
    transok: "翻译",
    transplacholder: "请输入您要翻译的文字...",
    transplacholderNew: "请输入您要翻译的文字，新用户可免费使用5次...",
    resultplacholder: "译文",


    convertplacholder: "请输入待转换原文...",
    convertresultplacholder: "转换文本",
    convertmo: "传统蒙古文",
    convertkiril: "西里尔文",


    allnewupdatetag: "全新升级",



    codeconvert_select_outcode: "请选择输出编码",
    codeconvert_sourcecode_outcode_eq_msg: "输入编码和输出编码一致，请选择不同类型编码",
    codeconvert_tips: "已转成",


    copyd: "已复制",
    copydfail: "复制失败，请手动复制",
    copydnull: "没有可复制内容",
    serviceerr: "接口出错",
    source_target_eq_msg: "原始语言必须和目标语言不一样，请重新选择！",

    // site_convert_title: "蒙古文转换-传统蒙古文西里尔文互转",
    // site_code_convert_title: "Onon编码转换-国标、民委共享工程、蒙科立编码互转",
    // site_translate_title: "Onon翻译-蒙古文、中文、英文互译",

    site_convert_title: "蒙古文转换-传统蒙古文与西里尔文智能互转",
    site_code_convert_title: "编码转换-精准高效的多格式转换",
    site_translate_title: "Onon翻译 - 蒙汉翻译在线工具",

    check_codeconvert_slected_tips: "检测到源编码类型与上次记录目标编码类型一致，已为您自动重置目标编码类型",
    wxtips: "温馨提示",

    placewait: "请稍后",


    maxlimit: "超出指定限制",
    proofread: "文字校对",

    myTraffic: "我的资源",
    statisticalInformation: "统计信息",
    orderManagement: "订单管理",
    noRealNameUser: "未实名用户",
    ononbook: "Onon 图书",
    ononLanguageResources: "Onon 语言资源",

    productCenter: "产品中心",
    internetService: "网络服务",
    officeSoftware: "办公软件",
    languageIndustry: "语言产业",
    productSupport: "产品支持",
    aboutUs: "关于我们",
    followUs: "关注我们",
    ononCollege: "斡仑学院",
    userGuide: "使用指南",
    audioBook: "随书音频",
    qualificationHonor: "资质荣誉",
    JoinUs: "招贤纳士",
    mediaReports: "媒体报道",
    legalNotices: "法律声明",

    pleaseLogInToTranslate: "请登录后翻译",
    buy: "购买",
    invoiceManagement: "发票管理",

    myMembers: "我的会员",
    remainingFlow: "剩余资源",
    maturity: "到期",
    character: "字符",
    frequency: "次",
    word: "字",

    automaticDetection: "自动检测",
    unableToTecognizeLanguage: "不支持当前语言检测，请输入传统蒙古文、中文、英文",

    limitedExemption: '限免',

    weChatGroup: "微信群",
    technicalServices: "技术服务",
    feedback: "建议反馈",

    PleasLogInToConvert: "请登录后再转换",
    loggedOut: "已退出登录",

    realTimeTranslation: "实时翻译",
    paste: "粘贴",
    clipboardIsEmpty: "剪贴板为空",
    kindTips: "温馨提示",
    moreApplications: "更多应用",
    free5: "您的免费使用次数已用完，请登录后继续使用！<br> 新用户注册登录，即可获得3000字符额度。",
    openVip: "开通会员",
    ISee: "知道了",
    OnlineFeedback: "在线反馈"
};